import { Progress } from "@/common/components/ui/progress";
import { SectionTitle } from "../utils/helpers.jsx";

export default function TestsOverview({ overview, isTableView = false }) {
  // If table view is enabled, render the table format
  if (isTableView) {
    return (
      <div className="mb-6 md:mb-8">
        <SectionTitle title="📊 Test Overview" />
        <div className="overflow-x-auto print:overflow-visible">
          <table className="w-full border border-collapse border-gray-200 print:border-collapse">
            <thead>
              <tr className="bg-gray-50 print:bg-gray-100">
                <th className="px-4 py-2 font-medium text-left border text-slate-600 print:font-bold print:text-black">
                  Category
                </th>
                <th className="px-4 py-2 font-medium text-left border text-slate-600 print:font-bold print:text-black">
                  Tests Assigned
                </th>
                <th className="px-4 py-2 font-medium text-left border text-slate-600 print:font-bold print:text-black">
                  Tests Completed
                </th>
                <th className="px-4 py-2 font-medium text-left border text-slate-600 print:font-bold print:text-black">
                  Questions Attempted
                </th>
                <th className="px-4 py-2 font-medium text-left border text-slate-600 print:font-bold print:text-black">
                  Time Spent
                </th>
                {/* <th className="px-4 py-2 font-medium text-left border text-slate-600 print:font-bold print:text-black">
                  Average Accuracy
                </th> */}
                {/* <th className="px-4 py-2 font-medium text-left border text-slate-600 print:font-bold print:text-black">
                  Band
                </th> */}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-4 py-3 font-medium border">Tests</td>
                <td className="px-4 py-3 text-center border">
                  {overview.testAssigned}
                </td>
                <td className="px-4 py-3 text-center border">
                  {overview.testcompleted}
                </td>
                <td className="px-4 py-3 text-center border">
                  {overview.questionsAttempted}
                </td>
                <td className="px-4 py-3 text-center border">
                  {overview.timeSpent}
                </td>
                {/* <td className="px-4 py-3 text-center border">
                  {overview.averageCorrectPercentage}%
                </td> */}
                {/* <td className="px-4 py-3 border">
                  <span
                    className={`px-2 py-1 text-xs font-medium rounded ${
                      overview.averageCorrectPercentage >= 75
                        ? "bg-green-100 text-green-800"
                        : overview.averageCorrectPercentage >= 50
                        ? "bg-blue-100 text-blue-800"
                        : overview.averageCorrectPercentage >= 25
                        ? "bg-yellow-100 text-yellow-800"
                        : "bg-red-100 text-red-800"
                    } print:font-bold`}
                  >
                    {overview.averageCorrectPercentage >= 75
                      ? "Excellent"
                      : overview.averageCorrectPercentage >= 50
                      ? "Good"
                      : overview.averageCorrectPercentage >= 25
                      ? "Average"
                      : "Needs Improvement"}
                  </span>
                </td> */}
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-3 text-xs text-gray-500 print:text-xs print:mt-2">
          This overview represents the overall assessment performance across all
          tests.
        </p>
      </div>
    );
  }

  // Original card view
  return (
    <div className="mb-6 md:mb-8">
      <SectionTitle title="Tests Overview" />
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
        <div className="p-3 border border-blue-100 rounded-lg bg-blue-50 md:p-4">
          <p className="text-xs md:text-sm text-slate-500">Test Assigned</p>
          <p className="text-xl font-bold md:text-2xl text-slate-900">
            {overview.testAssigned}
          </p>
        </div>
        <div className="p-3 border border-green-100 rounded-lg bg-green-50 md:p-4">
          <p className="text-xs md:text-sm text-slate-500">Completed</p>
          <p className="text-xl font-bold md:text-2xl text-slate-900">
            {overview.testcompleted}
          </p>
        </div>
        <div className="p-3 border border-purple-100 rounded-lg bg-purple-50 md:p-4">
          <p className="text-xs md:text-sm text-slate-500">
            Questions Attempted
          </p>
          <p className="text-xl font-bold md:text-2xl text-slate-900">
            {overview.questionsAttempted}
          </p>
        </div>
        <div className="p-3 border rounded-lg bg-amber-50 md:p-4 border-amber-100">
          <p className="text-xs md:text-sm text-slate-500">Time Spent</p>
          <div className="flex items-center gap-2">
            <p className="text-xl font-bold md:text-2xl text-slate-900">
              {overview.timeSpent}
            </p>
          </div>
        </div>
      </div>

      {/* Progress bar for average accuracy */}
      {/* <div className="p-3 mt-4 border rounded-lg">
        <div className="flex justify-between mb-1 text-xs text-gray-500">
          <span>Average Accuracy</span>
          <span>{overview.averageCorrectPercentage}%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5">
          <div
            className={`h-2.5 rounded-full ${
              overview.averageCorrectPercentage >= 75
                ? "bg-green-500"
                : overview.averageCorrectPercentage >= 50
                ? "bg-blue-500"
                : overview.averageCorrectPercentage >= 25
                ? "bg-yellow-500"
                : "bg-red-500"
            }`}
            style={{ width: `${overview.averageCorrectPercentage}%` }}
          ></div>
        </div>
        <p className="mt-2 text-xs text-gray-500">
          This represents the overall accuracy of the student's answers across
          all assessments.
        </p>
      </div> */}
    </div>
  );
}
